import { useQuery } from '@apollo/client'


import { parseBlockPayload } from '@entities/MainPageConfig/model/helpers'
import { GQL_QUERY_MAIN_PAGE_CONFIG } from '@entities/MainPageConfig/model/queries'
import type { MainPageConfig, MainPageConfigQuery, MainPageConfigQueryVariables } from '@entities/MainPageConfig/model/types'


export function useMainPageConfig (id?: string | number) {
  const { data, loading, error, refetch } = useQuery<MainPageConfigQuery, MainPageConfigQueryVariables>(GQL_QUERY_MAIN_PAGE_CONFIG, {
    variables: {
      id: id ?? null,
      type: 'delivery'
    },
    fetchPolicy: 'cache-and-network',
  })

  const mainPageConfig: MainPageConfig | undefined = data?.mainPageConfig
    ? {
      ...data.mainPageConfig,
      blocks: data.mainPageConfig.blocks.map((block) => ({
        ...block,
        payload: parseBlockPayload(block),
      })),
    }
    : {
      id: 'default',
      blocks: [],
    }

  return {
    mainPageConfig,
    data,
    loading,
    error,
    refetch,
  }
}